<template>
    <div>
        <page-navigate></page-navigate>
        <div id="pageContainer">
            <section class="container1">
                <div class="flex contentBox justify-between">
                    <div class="left">
                        <h1 class="super_large-72_bold md-title-32_bold word1">指数差价合约</h1>
                        <h2 class="subtitle-20_regular md-body-14_regular word3">
                            无需持有基础资产，灵活交易，掌控全球机遇
                        </h2>
                        <a :href="signupUrl" target="_blank">
                            <div class="pageBtn primary-default_large">
                                <span class="word2">立即开户</span>
                                <span class="iconfont icon-right"></span>
                            </div>
                        </a>
                    </div>
                    <img class="right" src="@/assets/image/trading-product/tradingproductIndexCfd.png" alt="" />
                </div>
            </section>
            <product-tab></product-tab>
            <section class="container2">

                <div class="contentBox container2Content">
                    <h2 class="text-center title-48_bold md-title-24_bold scroll-fade-up word6 scroll-fade-up">产品优势</h2>
                    <h3 class="text-center subtitle-20_regular md-footnote-regular_12 word7 scroll-fade-up">
                        无需持有基础资产，低成本，灵活杠杆，让您在市场涨跌中抓住每个机会
                    </h3>
                    <a href="https://edocs-1305385874.cos.ap-hongkong.myqcloud.com/web/EBC PRODUCT GUIDE_CN.pdf"
                        target="_blank">
                        <div class="primary-default_large jyBtn scroll-fade-up">交易产品指南</div>
                    </a>
                    <div class="topCardList flex scroll-fade-up">
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                                fill="none">
                                <path d="M32.9031 30.9487H9.01465V34.7402H32.9031V30.9487Z" stroke="#9F734C"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.9115 10.0127L9.01465 12.3469L10.68 11.8555L19.3993 9.30627"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M32.9021 5.25916L25.094 7.56609L23.9474 7.90394L31.322 5.72669L31.1617 5.80176L22.4424 8.351"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.959 10.0638V30.9491" stroke="#9F734C" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M20.9653 10.0637C21.6758 10.0637 22.2518 9.48771 22.2518 8.77716C22.2518 8.06661 21.6758 7.4906 20.9653 7.4906C20.2547 7.4906 19.6787 8.06661 19.6787 8.77716C19.6787 9.48771 20.2547 10.0637 20.9653 10.0637Z"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M12.8917 19.5002C12.8473 21.6058 11.1273 23.2882 9.01493 23.2882C6.90251 23.2882 5.17572 21.6058 5.13477 19.4968"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M12.9009 19.4965C10.7544 19.4965 9.01052 17.7561 9.01052 15.6061C9.01052 17.7527 7.27007 19.4965 5.12012 19.4965"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M36.7799 12.6749C36.7355 14.7805 35.0155 16.4629 32.9031 16.4629C30.7907 16.4629 29.0673 14.7771 29.0264 12.6715"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M36.7896 12.6745C34.643 12.6745 32.8992 10.934 32.8992 8.78406C32.8992 10.9306 31.1587 12.6745 29.0088 12.6745"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word8">灵活高杠杆</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word9">杠杆高达100:1，放大每笔交易收益，灵活管理风险
                            </div>
                        </div>
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                                fill="none">
                                <g clip-path="url(#clip0_2526_19405)">
                                    <path d="M20.5332 14.5823V22.5662L25.0163 25.4557" stroke="#A52933"
                                        stroke-linecap="round" />
                                    <path
                                        d="M29.717 27.1199C27.6844 29.5861 24.6069 31.1536 21.1583 31.1536C15.0346 31.1536 10.0656 26.1898 10.0656 20.0608H13.0334L8.4249 12.077L3.81641 20.0661H6.69018C6.69018 28.0552 13.1692 34.5342 21.1583 34.5342"
                                        stroke="#9F734C" stroke-linecap="round" />
                                    <path
                                        d="M12.5996 13.0125C14.6322 10.5462 17.7097 8.97872 21.1582 8.97872C27.282 8.97872 32.251 13.9425 32.251 20.0715H29.2832L33.8917 28.0554L38.5002 20.0715H35.6264C35.6264 12.0824 29.1473 5.60333 21.1582 5.60333"
                                        stroke="#9F734C" stroke-linecap="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_2526_19405">
                                        <rect width="40" height="40" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word10">实时弹性定价</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word11">
                                根据全球市场波动实时调整，确保您每笔交易享受最优交易条件
                            </div>
                        </div>
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                                fill="none">
                                <path d="M23.3567 21.9231V16.4487M6.21387 5.49994H14.3567M6.21387 9.44151H10.2853"
                                    stroke="#A52933" stroke-linecap="round" />
                                <path
                                    d="M14.3933 24.7699C14.2296 24.0672 14.1429 23.334 14.1429 22.5801C14.1429 17.3798 18.2682 13.1642 23.3571 13.1642C28.446 13.1642 32.5714 17.3798 32.5714 22.5801C32.5714 27.7804 28.446 31.9961 23.3571 31.9961H10.7143M20.7857 28.4925H6M23.3571 35.4997H15.4286M14.3933 13.1642L12.8571 12.0693M32.5714 13.1642L34.0714 11.6313M20.7857 9.87952V5.5H26.1429V9.87952M19.2857 5.5H27.8571"
                                    stroke="#9F734C" stroke-linecap="round" />
                                <path
                                    d="M23.3567 35.5C30.3392 35.5 35.9996 29.7157 35.9996 22.5804C35.9996 15.4451 30.3392 9.66083 23.3567 9.66083C16.3743 9.66083 10.7139 15.4451 10.7139 22.5804C10.7139 23.4808 10.804 24.3597 10.9755 25.2081"
                                    stroke="#9F734C" stroke-linecap="round" />
                                <ellipse cx="23.432" cy="23.3139" rx="1.21622" ry="1.24284" stroke="#A52933"
                                    stroke-linecap="round" />
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word12">极致的交易速度</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word13">平均执行速度 20ms，助您抢占市场先机
                            </div>
                        </div>
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34"
                                fill="none">
                                <g clip-path="url(#clip0_2526_19426)">
                                    <path
                                        d="M24.0901 17.1903C24.0901 21.2421 20.8525 24.5274 16.8595 24.5274C12.8666 24.5274 9.62891 21.2421 9.62891 17.1903C9.62891 13.1385 12.8666 9.85315 16.8595 9.85315C20.8525 9.85315 24.0901 13.1385 24.0901 17.1903Z"
                                        stroke="#A52933" stroke-linecap="round" />
                                    <path
                                        d="M19.0527 15.2519C18.3359 13.309 15.0982 13.5433 15.0742 15.5643C15.0646 16.4674 16.1085 16.8824 16.9841 17.024C20.1688 17.5316 19.2884 20.5729 16.9841 20.4558C15.2377 20.3679 14.7326 19.167 14.6797 18.8839"
                                        stroke="#A52933" stroke-linecap="round" />
                                    <path d="M17.0176 12.2888V13.9144" stroke="#A52933" stroke-linecap="round" />
                                    <path d="M17.0176 20.4615V22.0871" stroke="#A52933" stroke-linecap="round" />
                                    <path
                                        d="M1.49707 5.08461L5.6584 8.32603M11.3835 1.41339L12.7305 5.1625M22.6597 1.53567L21.3559 5.16274M32.5892 5.08461L28.4278 8.32603M1.49707 29.2922L5.6584 26.0508M11.3835 32.9631L12.7305 29.214M22.703 32.9631L21.3559 29.214M32.5892 29.2922L28.4278 26.0508M17.0407 27.0079C23.8047 27.0079 29.6594 23.0196 32.5892 17.1909C29.6642 11.3573 23.8047 7.37385 17.0407 7.37385C10.2768 7.37385 4.42203 11.3573 1.49707 17.1909C4.42203 23.0244 10.2816 27.0079 17.0407 27.0079Z"
                                        stroke="#9F734C" stroke-linecap="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_2526_19426">
                                        <rect width="33.6207" height="33.6207" fill="white"
                                            transform="translate(0.189453 0.333252)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word14">完全透明的交易</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word15">无隐藏费用或额外成本，确保您每笔交易的透明和公平
                            </div>
                        </div>
                    </div>
                    <h2 class="text-center title-48_bold md-title-24_bold scroll-fade-up">市场报价</h2>
                    <div id="pageOverLay"></div>
                    <product-module-new />
                    <div class="expandTable">
                        <h2 class="text-center title-48_bold md-title-24_bold scroll-fade-up word4 scroll-fade-up">
                            全球指数点差下调</h2>
                        <h3 class="text-center subtitle-20_regular md-footnote-regular_12 word5 scroll-fade-up">
                            点差大幅度降低，流动性增加，享受覆盖全球市场的低成本交易</h3>
                        <div class="tableOverflowScrollContainer scroll-fade-up" style="position: relative;">
                            <div class="corner-mask mobile"></div>
                            <div class="fake-scrollbar mobile">
                                <div class="fake-thumb"></div>
                            </div>
                            <div class="tableOverflowScroll">

                                <div class="expandTableWrapper">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th class="body-16_medium thFirst" rowspan="2">品种</th>
                                                <th class="body-16_medium" rowspan="2">指数描述</th>
                                                <th class="body-16_medium" colspan="3">指数点差</th>
                                                <th class="body-16_medium" rowspan="2">降幅</th>

                                            </tr>
                                            <tr>
                                                <th class="body-16_medium">亚洲时间</th>
                                                <th class="body-16_medium">欧洲时间</th>
                                                <th class="body-16_medium">美国时间</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="body-14_regular">U30USD</td>
                                                <td class="body-14_regular">美国道琼斯工业平均指数</td>
                                                <td class="body-14_regular">1.30</td>
                                                <td class="body-14_regular">1.30</td>
                                                <td class="body-14_regular">1.00</td>
                                                <td class="body-16_medium">-<span id="number1">70</span>%
                                                    <span class="iconfont icon-up2"></span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="body-14_regular">SPXUSD</td>
                                                <td class="body-14_regular">美国标准普尔500指数</td>
                                                <td class="body-14_regular">0.30</td>
                                                <td class="body-14_regular">0.31</td>
                                                <td class="body-14_regular">0.31</td>
                                                <td class="body-16_medium">-<span id="number2">64</span>%
                                                    <span class="iconfont icon-up2"></span>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="body-14_regular">NASUSD</td>
                                                <td class="body-14_regular">美国纳斯达克100指数</td>
                                                <td class="body-14_regular">0.70</td>
                                                <td class="body-14_regular">0.70</td>
                                                <td class="body-14_regular">0.70</td>
                                                <td class="body-16_medium">-<span id="number3">85</span>%
                                                    <span class="iconfont icon-up2"></span>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="body-14_regular">HSIHKD</td>
                                                <td class="body-14_regular">香港恒生指数</td>
                                                <td class="body-14_regular">6.50+</td>
                                                <td class="body-14_regular">6.50</td>
                                                <td class="body-14_regular">6.50</td>
                                                <td class="body-16_medium">-<span id="number4">55</span>%
                                                    <span class="iconfont icon-up2"></span>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="body-14_regular">CNIUSD</td>
                                                <td class="body-14_regular">中国A50指数</td>
                                                <td class="body-14_regular">6.00+</td>
                                                <td class="body-14_regular">6.00</td>
                                                <td class="body-14_regular">6.00</td>
                                                <td class="body-16_medium">-<span id="number5">14</span>%
                                                    <span class="iconfont icon-up2"></span>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <open-account></open-account>
            <section class="container4 commonQuestion">
                <div class="contentBox">
                    <h2 class="scroll-fade-up">常见问题</h2>
                    <div class="QA-list">
                        <div class="QA-item">
                            <div class="QA-title">1.什么是指数CFD？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    指数CFD，一般指的是股票指数CFD，可以反映股票指数的价格变化并提供价格变动带来的盈利或亏损。
                                </p>
                                <p class="QA-li">
                                    相比于单一的股票投资，股票指数反映了一组具有代表性股票的走势，是一国某个行业甚至是整体经济的晴雨表。比如德国DAX
                                    30指数，是由该国30支最具代表性的蓝筹股组成，反映了德国股市的整体状况。
                                </p>
                                <p class="QA-li">
                                    通过指数CFD，可以将对单只股票复杂的判断简化为分析整体市场情绪，从而分散风险，并规避个股极端的价格波动，整体的安全性更高。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">2.指数CFD可以交易什么？</div>
                            <div class="QA-content">
                                <p class="QA-li">指数CFD可以交易全球股票指数。</p>
                                <p class="QA-li">
                                    EBC甄选全球主流指数，包括道琼斯指数、DAX 30指数、STOXX
                                    50指数、标普500指数和日经225指数等。只需要一个EBC账户，就可以在全球众多市场中进行选择，并通过EBC极具竞争力的点差和灵活的杠杆比率，在全球众多极其活跃的市场中取得成功。
                                </p>
                            </div>
                        </div>

                        <div class="QA-item">
                            <div class="QA-title">3.指数CFD交易杠杆？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    EBC可以为指数
                                    CFD交易提供最高100倍的杠杆，这是在合规和监管范围内所允许的最大杠杆比例，充分考虑了安全性和资金利用率的平衡。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">4.指数CFD合约量如何规定？</div>
                            <div class="QA-content">
                                <p class="QA-li">不同指数对应的合约量也是不同的。</p>
                                <p class="QA-li">
                                    EBC提供全球最主流的股指CFD，其中100GBP（英国富时100）、200AUD（澳洲标普200）、CNIUSD（中国A50指数）、D30EUR（德国DAX30）、E50EUR（欧洲STOXX50）、F40EUR（法国CAC40）、HSIUSD（香港50指数）、NASUSD（美国纳斯达克100指数）、U30USD（美国股票30指数）一手合约量是10。
                                </p>
                                <p class="QA-li">
                                    225JPY（日经225指数）、SPXUSD（标普500指数）一手合约量是100。
                                </p>
                                <p class="QA-li">指数CFD的最小手数均为0.1手。</p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">5.指数CFD交易有哪些优势？</div>
                            <div class="QA-content">
                                <p class="QA-li">提高资金利用率</p>
                                <p class="QA-li">
                                    指数交易的杠杆通常比较低，但是通过指数CFD，可以占用更少的资金参与交易。但记住，杠杆和风险是相伴而行的，在进行杠杆交易时一定要保持仓位控制。
                                </p>
                                <p class="QA-li">
                                    双向交易
                                    股票指数反映了股市的整体走向。通过指数CFD，可以多空双向交易，获取更大盈利空间。
                                </p>
                                <p class="QA-li">
                                    分散风险
                                    股票指数往往是选出最具代表性的一揽子股票编制的，是某一个市场中最绩优股票的集合。单一股票的走势往往无法对指数产生直接的影响，有效分散了市场风险。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">6.如何学习参与指数CFD交易？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    由于指数CFD反映的是一揽子股票的走势，所以我们需要关注的是市场整体，而非局部。
                                </p>
                                <p class="QA-li">
                                    一般来说，股票指数和央行的货币政策、一国的经济数据直接相关。比如，如果一国央行实施的是紧缩性货币政策，市场会担心市场上缺乏资金，进而打压股市；同样的，如果一国经济数据不佳，会压低市场的投资预期，进而打压股市。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <message-v3></message-v3>

        <page-footer></page-footer>
    </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import {
    mapGetters,
} from 'vuex'
export default {
    mixins: [fadeAnimate],
    data() {
        return {
            infoData: "",
            newData: "",
            pagIndex: 0,
            num: 3,
            newsdisplay: "none"
        }
    },
    computed: {
        ...mapGetters([
            'signupUrl',
        ]),
    },
    destroyed() {
    },

    mounted() {
        this.initPage()
    },
    methods: {
        initPage() {
            const setTabActIdx = (idx, e) => {
                scrollTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                });
                floatTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                });
                floatTabElement[idx].classList.add("active");
                scrollTabElement[idx].classList.add("active");
                const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
                const leftPad = 32 * rem;
                const wrapper = document.querySelector(".scrollTabWrapper");
                wrapper.scrollLeft = idx <= 1 ? 0 : e.target.offsetLeft - leftPad;
            };
            const scrollTabElement = document.querySelectorAll(
                ".scrollTabWrapper .tabItem"
            );
            const floatTabElement = document.querySelectorAll(".floatTab .tabItem");
            floatTabElement.forEach((item, idx) => {
                item.addEventListener("click", function (e) {
                    jumpPage(idx);
                });
            });
            scrollTabElement.forEach((item, idx) => {
                item.addEventListener("click", function (e) {
                    jumpPage(idx);
                });
            });
            let tabIndex = 0;

            if (location.href.includes("/commodity/")) {
                tabIndex = 1;
            } else if (location.href.includes("/index-cfds/")) {
                tabIndex = 2;
            } else if (location.href.includes("/share-cfds/")) {
                tabIndex = 3;
            } else if (location.href.includes("/etf/")) {
                tabIndex = 4;
            } else if (location.href.includes("/crypto/")) {
                tabIndex = 5;
            }
            setTabActIdx(tabIndex, { target: floatTabElement[tabIndex] });
            setTabActIdx(tabIndex, { target: scrollTabElement[tabIndex] });
            function jumpPage(idx) {
                const pathArr = location.pathname.split("/");
                const len = pathArr.length;
                const targetArr = ["forex", "commodity", "index-cfds", "share-cfds", "etf", 'crypto'];
                pathArr[len - 2] = targetArr[idx];
                location.href = pathArr.join("/");
            }
            debugger
            console.log(ProductVM, 1111)
            ProductVM.changeHandle(tabIndex);
            document.addEventListener("mountedSuccess", (e) => {
                ProductVM.changeHandle(tabIndex);
            });



        }
    }
}

</script>
<style scoped lang="scss">
@import url("../assets/css/commonQuestion.scss");

* {
    font-family: Inter, Noto Sans Sc, sans-serif;
}

.message-new .gender-btn::before {
    box-sizing: border-box;
}

.message-new {
    max-width: 1200rem;
    padding-inline: calc((100vw - 1200rem) / 2) !important;
    box-sizing: content-box;
}

.message-new .p1 {
    font-size: 48rem !important;
    line-height: 56rem !important;
}

.contentBox {
    max-width: 1200rem;
    margin-inline: auto;
}

body.no-scroll {
    overflow: hidden;
}

#pageOverLay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    display: none;
    opacity: 0;
    transition: opacity 0.6s ease;
}

.pageContainer {
    position: relative;
}

#pageContainer {
    background: var(--ebc-neutral-bg_a)
}

#pageContainer .pageBtn {
    gap: 4rem;
    min-width: 180rem;
    width: fit-content;
    cursor: pointer;
}

#pageContainer a {
    width: fit-content;
    display: block;
    margin-inline: auto;
}

.container1 {
    padding-top: calc(80px + 15rem);
    height: 560rem;
    background: var(--ebc-neutral-bg_c);
}

.container1 .left {
    flex: 0 0 770rem;
}

.container1 .left h2 {
    margin: 24rem 0 64rem;
    color: var(--ebc-text-secondary);
}


.container1 .right {
    height: 412rem;
}

.container1 a {
    margin: 0 !important;
}

@media (max-width: 996px) {
    html {
        overflow-x: hidden;
    }

    body {
        overflow-x: visible !important;
    }

    .message-new .p1 {
        font-size: 48rem !important;
        line-height: 72rem !important;
    }

    .container1 {
        padding: 80rem 32rem;
        height: auto;
        overflow-x: hidden;
    }

    .container1 .right {
        /* width: 586rem; */
        height: 586rem;
        margin: 0 auto 80rem;
    }

    .container1>div {
        flex-direction: column;
    }

    .container1 .left {
        order: 2;
        text-align: center;
        flex: 1;
    }

    .container1 .left h2 {
        margin-top: 16rem;
    }

    #pageContainer .container1 a {
        width: 100%;
    }

    #pageContainer .container1 .left .pageBtn {
        width: 100%;
    }

}


.container2 {
    background: var(--ebc-neutral-bg_a);
    margin-top: -64rem;
}

.pt .floatTab,
.es .floatTab {
    width: 900rem;
}

.floatTab {
    position: sticky;
    transform: translateY(-50%);
    z-index: 98;
    top: 128px;
    margin-inline: auto;
    background: var(--ebc-basecolor-white-85);
    border-radius: var(--ebc-corner-radius-full);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(10px);
    padding: 4rem;
    gap: 8rem;
    width: 792rem;
    height: 64rem;
}

.floatTab .tabItem {
    flex: 1;
    color: var(--ebc-text-secondary);
}

.floatTab .active {
    border-radius: var(--ebc-corner-radius-full);
    background: var(--ebc-neutral-bg_c);
    color: var(--ebc-text-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-weight: 500;
}

.container2 .container2Content {
    padding: 120rem 0;
}

/* .container2 .container2Content>a:last-of-type{
  display:none!important
} */

.container2 h2 {
    margin-bottom: 16rem;
}

.tradingProductPage .container2 h2 {
    max-width: 850rem;
    margin-inline: auto;
}

.container2 h3 {
    max-width: 850rem;
    margin-inline: auto !important;
}

.container2 h3 {
    margin: 16rem 0;
    color: var(--ebc-text-secondary);
}

.container2 .pageBtn {
    margin: 60rem auto 0;
}

@media (max-width: 996px) {
    html {
        height: auto !important;
        min-height: auto !important;
    }

    .container2 {
        padding: 0 32rem;
        margin-top: 0;
    }

    .container2 .container2Content .btnTop {
        height: 64rem;
        font-size: 28rem;
        gap: 8rem;
        line-height: 44rem;
    }

    .container2 .pageBtn {
        height: 80rem;
        font-size: 28rem;
        line-height: 44rem;
        margin-top: 80rem;
    }

    .floatTab {
        display: none !important;
    }

    .container2 .container2Content {
        padding: 64rem 0 160rem;
    }

    .container2 h3 {
        margin: 16rem 0;
    }

    .scrollTab {
        display: inline-flex;
        gap: 16rem;
        min-width: fit-content;
    }

    .scrollTabWrapper {
        overflow-x: auto;
        scroll-behavior: smooth;
        padding: 16rem 32rem;
        margin-top: 64rem;
        background: var(--ebc-neutral-bg_a);
        position: sticky;
        top: 44px;
        z-index: 99
    }

    .scrollTabWrapper::-webkit-scrollbar {
        display: none;
    }

    .scrollTab .tabItem {
        color: var(--ebc-text-secondary);
        padding: 16rem 32rem;
        flex: 1;
        background: var(--ebc-neutral-bg_b);
        border-radius: var(--ebc-corner-radius-full);
        white-space: nowrap;
    }

    .scrollTab .active {
        background: var(--ebc-basecolor-active-500);
        color: var(--ebc-text-primary_white);
        font-weight: 500;
    }
}




.container1 {
  padding-top: 104rem;
}
.container1 .left {
  flex: 0 0 590rem;
  padding-top: 56rem;
  align-self: flex-start;
}

.container1 .right {
  height: 392rem;
}
@media (min-width: 996px) {
  .mn .container1 .left h1,
  .ru .container1 .left h1,
  .ug .container1 .left h1,
  .es .container1 .left h1{
    white-space: nowrap;
  }
  .mn .container1 h1{
    font-size: 60rem;
    white-space: nowrap;
    line-height: 68rem;
  }
  
}
@media (max-width: 996px) {
  .container1 {
    padding-top: 80rem;
  }
  .container1 .left {
    width: 100%;
    flex: 1;
    align-self: center;
    padding-top: 0;
  }
  .container1 .right {
    height: 450rem;
  }
}

.container2 h3 {
  margin: 16rem 0 60rem;
}
.container2 .contentBox {
  padding-top: 88rem;
}

.container2 .topCardList {
  margin-bottom: 120rem;
  gap: 24rem;
  align-items: stretch;
}

.container2 .topCardList .card {
  flex: 1;
  border-radius: var(--ebc-corner-radius-rc16);
  background: var(--ebc-neutral-bg_b);
  padding: 32rem 24rem;
  border:0;
}
.container2 .topCardList .card h3 {
  margin: 16rem 0;
  color: var(--ebc-text-primary);
  width: 100%;
}

.container2 .topCardList .card div {
  color: var(--ebc-text-secondary);
}
.expandTable {
  padding-top: 120rem;
}

.expandTable table {
  border-collapse: separate;
  border-spacing: 0; /* 可选：去掉单元格间距 */
}
.expandTable thead tr:first-child th:first-child{
  border:1px solid var(--ebc-neutral-divider_medium);
  border-top-left-radius:var(--ebc-corner-radius-rc16);
}
.ar .expandTable thead tr:first-child th:first-child{
  
  border-top-left-radius: 0;
  border-top-right-radius: var(--ebc-corner-radius-rc16);
}
.expandTable thead tr:first-child th{
  border-top:1px solid var(--ebc-neutral-divider_medium);

}
.expandTable thead tr:first-child th:last-child{
  border:1px solid var(--ebc-neutral-divider_medium);
  border-left:0;
  border-top-right-radius:var(--ebc-corner-radius-rc16);
}
.ar .expandTable thead tr:first-child th:last-child{
  border-top-right-radius:0;
  border-top-left-radius:var(--ebc-corner-radius-rc16);

}

.expandTable tbody tr:last-child td:first-child{
  border:1px solid var(--ebc-neutral-divider_medium);
  border-top:0;
  border-bottom-left-radius:var(--ebc-corner-radius-rc16);
}
.ar .expandTable tbody tr:last-child td:first-child{
  border-bottom-left-radius:0;
  border-bottom-right-radius:var(--ebc-corner-radius-rc16);

}
.expandTable tbody tr td:first-child{
  border-left:1px solid var(--ebc-neutral-divider_medium);
}
.expandTable tbody tr:last-child td:last-child{
  border:1px solid var(--ebc-neutral-divider_medium);
  border-top:0;
  border-left:0;
  border-bottom-right-radius:var(--ebc-corner-radius-rc16);
}
.ar .expandTable tbody tr:last-child td:last-child{
  border-bottom-right-radius:0;
  border-bottom-left-radius:var(--ebc-corner-radius-rc16);

}

.expandTable tr:first-child th:first-child {
  width: 160rem;
}
.expandTable tr:first-child th:nth-child(2) {
  width: 360rem;
}
.expandTable tr:first-child th:nth-child(3) {
  width: 515rem;
}
.expandTable tr:first-child th:nth-child(4) {
  width: 160rem;
}
.expandTable th {
  background: var(--ebc-neutral-bg_c);
  padding: 24rem 10rem;
  text-align: center;
  vertical-align: middle;
}
.expandTable td {
  padding: 21rem 0;
  text-align: center;
}
.expandTable th,
.expandTable td {
  border-right: 1px solid var(--ebc-neutral-divider_medium);
  border-bottom: 1px solid var(--ebc-neutral-divider_medium);
}
.ar .expandTable th,
.ar .expandTable td{
  border-right:0;
  border-left:1px solid var(--ebc-neutral-divider_medium)!important;
}
.ar .expandTable tbody tr td:first-child{
  border-right: 1px solid var(--ebc-neutral-divider_medium)!important;
}
.expandTable td:last-child {
  color: var(--ebc-basecolor-active-500);
  display:flex;
  align-items: center;
  justify-content: center;
}
.expandTable tr td span.iconfont {
  display: inline-block;
  transform: rotate(180deg);
  font-size: 12rem;
  font-weight: 400;
}
.container2 .jyBtn{
  margin-bottom: 60rem;
  min-width: 180rem;
}
@media (max-width: 996px) {
  .container2 .jyBtn{
    height: 80rem;
  margin-bottom: 80rem;
  min-width: unset;
  font-size: 28rem;
  line-height: 44rem;
  font-weight: 500;
}
  .container2 .topCardList {
    margin-bottom: 160rem;

    gap: 32rem;
    flex-wrap: wrap;
  }
  .container2 .topCardList .card h3 {
    margin: 32rem 0 16rem;
    color: var(--ebc-text-primary);
  }
  .container2 .topCardList .card {
    padding: 32rem;
          flex:0 0 calc(50% - 16rem);
          max-width: calc(50% - 16rem);
  }

  .tableOverflowScroll .expandTableWrapper {
    width: 2400rem;
  }
  .expandTable tr td span.iconfont {
    font-size: 24rem;
    transform: rotate(180deg);
  }
  .expandTable tr:first-child th:first-child {
    width: 320rem;
  }
  .expandTable tr:first-child th:nth-child(2) {
    width: 720rem;
  }
  .expandTable tr:first-child th:nth-child(3) {
    width: 1030rem;
  }
  .expandTable tr:first-child th:nth-child(4) {
    width: 320rem;
  }
  .expandTable .expandTableWrapper{
    position: relative;
    overflow:visible
  }
    .tableOverflowScroll {
    padding-bottom: 32rem;
    overflow: auto;
    max-width: 686rem;
    position:relative;
  }
  .tableOverflowScroll::-webkit-scrollbar {
    display:none
  }
  .tableOverflowScroll {
  position: relative;
  width: 100%;
}



/* 伪滚动条容器 */
.expandTable .fake-scrollbar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 4px;
  background: rgba(0, 0, 0, .1);
  border-radius: 2px;
  pointer-events: none;                /* 只看不点 */
}
/* 伪滑块 */
.expandTable .fake-thumb {
  height: 100%;
  background: rgba(0, 0, 0, .4);
  border-radius: 2px;
  width: 0;                            /* js 动态算 */
  transition: width .2s;
}
  .expandTable tr:first-child th:first-child{
    position: sticky;
    left: 0;
    z-index:10;
    /* overflow:hidden; */
  }

  .expandTable tr td:first-child{
    background:#fff;
    position: sticky;
    left: 0;
    z-index:10;

  }
  .noScroll th:first-child::after,
  .noScroll td:first-child::after{
    display:none!important;
  }
    .expandTable th.thFirst:first-child::after,
  .expandTable td:first-child::after {
         content: '';
        position: absolute;
        top: 0;
        right: -8px;          /* 控制阴影条水平位置 */
        width: 8px;           /* 阴影条宽度 */
        height: 100%;         /* 贯穿整个行高 */
        background: linear-gradient(to right, rgba(0,0,0,0.08), transparent);
        pointer-events: none; /* 不影响点击 */
  }
  .corner-mask {
  position: absolute;
  top: -10rem;
  left: -10rem;
  width: 12px;                /* 等于圆角半径 */
  height: 100%;
  background: #fff;           /* 与第一列背景同色 */
  z-index: 2;                 /* 盖住滚动内容 */
  pointer-events: none;       /* 不影响点击 */
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}
}

</style>